import { module } from 'stereomodularjs';
import { createApp } from "vue/dist/vue.esm-bundler.js"
import Listing from '../components/Listing.vue'
import Sidebar from '../components/Sidebar.vue'
import Pager from '../components/Pager.vue'
import Card from '../components/Card.vue'
import Controls from '../components/Controls.vue'
import svgIco from '../components/svgIco.vue'
import MultiRangeSlider from "multi-range-slider-vue";

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let self = this;
        let data = JSON.parse(this.el.dataset.listing);
        data.reloadTimeout = null;
        data.sidebarActive = false;
        const app = createApp({
            template: '<Listing />',
            components: {
                Listing,

            },
            data() {
                return data;
            },
            methods: {
                resetFilters() {
                    this.filters.makes.forEach(make => {
                        make.selected = false;
                        make.models.forEach(model => {
                            model.selected = false;
                        });
                    });
                },
                reloadListing() {
                    
                    let url = '/inventaire/';
                    let fd = new FormData();

                    this.selectedInventory.forEach(element => {
                        fd.append('inventory[]', element.value);
                    });
                    this.selectedMakes.forEach(element => {
                        fd.append('makes[]', element.value);
                        element.models.filter(i => i.selected).forEach(model => {
                            fd.append('models[]', model.value);
                        });
                    });
                    this.selectedTypes.forEach(element => {
                        fd.append('carcategory[]', element.value);
                    });
                    if (this.filters.yearMinRange != this.filters.yearMin || this.filters.yearMaxRange != this.filters.yearMax) {
                        fd.append('anneerange', this.filters.yearMin+';' + this.filters.yearMax);
                    }
                    // Same for price
                    if (this.filters.priceMinRange != this.filters.priceMin || this.filters.priceMaxRange != this.filters.priceMax) {
                        fd.append('pricerange', this.filters.priceMin+';' + this.filters.priceMax);
                    }
                    // Same for kms
                    if (this.filters.kmsMinRange != this.filters.kmsMin || this.filters.kmsMaxRange != this.filters.kmsMax) {
                        fd.append('kmrange', this.filters.kmsMin+';' + this.filters.kmsMax);
                    }
                    // Same for weekly
                    if (this.filters.weeklyMinRange != this.filters.weeklyMin || this.filters.weeklyMaxRange != this.filters.weeklyMax) {
                        fd.append('range', this.filters.weeklyMin+';' + this.filters.weeklyMax);
                    }

                    if (this.sort != 'issitemake') {
                        fd.append('order', this.sort);
                    }
                    if (this.rev) {
                        fd.append('rev', this.rev);
                    }
                    if (this.q) {
                        fd.append('q', this.q);
                    }

                    if (this.page > 1) fd.append('pg', this.page);
                    history.replaceState({}, '', url + '?' + new URLSearchParams(fd).toString());
                    // Add cookie of last inventory url, path /
                    document.cookie = 'lastInventoryUrl=' + url + '?' + new URLSearchParams(fd).toString() + '; path=/';

                    fd.append('output', 'json');
                    url = url + '?' + new URLSearchParams(fd).toString();
                    fetch(url).then(response => response.json())
                    .then(data => {

                        this.items = data.items;
                        this.featured = data.featured;
                        this.total = data.total;
                        this.page = data.page;
                        if (this.total == 0 && this.page > 1) {
                            this.page = 1;
                        }
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });
                },
            },
            computed: {
                pages() {
                    let pages = [];
                    let start = 1;
                    let end = this.totalPages;
                    for (let i = start; i <= end; i++) {
                        pages.push(i);
                    }
                    return pages;
                },
                totalPages() {
                    return Math.ceil(this.total / this.perPage);
                },
                selectedInventory() {
                    return this.filters.inventory.filter(i => i.selected);
                },
                selectedMakes() {
                    return this.filters.makes.filter(i => i.selected);
                },
                selectedModels() {
                    var models = [];
                    this.selectedMakes.forEach(element => {
                        let selectedModels = element.models.filter(i => i.selected);
                        selectedModels.forEach(model => {
                            models.push(model);
                        });
                    });
                    return models;
                },
                selectedTypes() {
                    return this.filters.types.filter(i => i.selected);
                }

            },
            watch: {
                page(val) {
                    setTimeout(() => {
                        this.reloadListing();
                        document.documentElement.scrollTop = 0;
                    });
                },
                sort(val) {
                    setTimeout(() => {
                        this.reloadListing();
                    },0);
                },
                q(val) {

                    setTimeout(() => {
                        this.reloadListing();
                    },0);
                },
                rev(val) {
                    setTimeout(() => {
                        this.reloadListing();
                    },0);
                },
                sidebarActive(val) {
                    document.documentElement.classList.toggle('-grid-cars-sidebar-active', val)
                },
                filters: {
                    handler(val) {
                        // Debounce the reload to trigger in 200ms after the last change
                        clearTimeout(this.reloadTimeout);
                        this.reloadTimeout = setTimeout(() => {
                            this.reloadListing();
                        }, 200);
                    },
                    deep: true
                }
            },
            mounted() { },
        })
        app.config.globalProperties.cash = (value) => {
            return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' $';
        }
        app.config.globalProperties.cents = (val) => {
            return parseFloat(val).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace('.', ',') + ' $';
        }
        app.config.globalProperties.pct = (val) => {
            return parseFloat(val).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace('.', ',') + ' %';
        }
        app.config.globalProperties.nb = (value) => {
            return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') ;
        }
        app.config.globalProperties.isNewQuery = () => {
            let selectedInventory = data.filters.inventory.filter(i => i.selected).map(i => i.value);
            if (selectedInventory.length == 0) {
                return false;
            }
            if (selectedInventory.includes('used')) {
                return false;
            }
            return true;
        }
        app.component("Sidebar", Sidebar)
        app.component("Pager", Pager)
        app.component("Card", Card)
        app.component("Controls", Controls)
        app.component("svgIco", svgIco)
        app.component("MultiRangeSlider", MultiRangeSlider)
        app.mount(self.el)
    }
}
